module.exports = __webpack_public_path__ + "media/images/gfx/edit_xs-c79f6d2aaab09472f956b73a141ce406.gif";